import { BasicImage as Atom } from '@components/Atoms';

export const BasicImage = ({ display = true, basic_image }) => {
  return display ? <Atom image={basic_image} /> : null;
};
